import { StatisticalAnalysisFilterByEnum } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-filter-by/statistical-analysis-filter-by.model'
import { StatisticalAnalysisTemporalFilterEnum } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-temporal-filter/statistical-analysis-temporal-filter.model'
import { StatisticalAnalysisDossiersExternalInfo, StatisticalAnalysisDossiersDatasourceResponsesTypes } from '@/modules/statistical-analysis-module/shared/models/shared.model'
import { StatisticalAnalysisGroupingResponseField } from '@/modules/statistical-analysis-module/shared/services/statistical-analysis-grouping/statistical-analysis-grouping.dto'
import { Nullable } from '@/shared/types/app.types'

export interface StatisticalAnalysisViewDetailTableExternalFiltering {
    filterType: Nullable<StatisticalAnalysisFilterByEnum>
    filterId: Nullable<number>
    sidebarFilters: Nullable<StatisticalAnalysisDossiersExternalInfo>
}

export interface StatisticalAnalysisViewDetailTableFilters{
    externalFiltering: StatisticalAnalysisViewDetailTableExternalFiltering
    temporalFilter: Nullable<StatisticalAnalysisTemporalFilterEnum>
    grouping: Nullable<StatisticalAnalysisGroupingResponseField[]>
}

export interface StatisticalAnalysisViewDetailTableState {
    loading: boolean
    filters: StatisticalAnalysisViewDetailTableFilters
    showModalTable: boolean
    showModalChart: boolean
    rowSelected: Nullable<StatisticalAnalysisDossiersDatasourceResponsesTypes>
    updateGrid: string
}
export const initialStatisticalAnalysisViewDetailTableState =
    (): StatisticalAnalysisViewDetailTableState => ({
        loading: false,
        filters: {
            externalFiltering: {
                filterType: null,
                filterId: null,
                sidebarFilters: null
            },
            // TODO Pass this info externally
            temporalFilter: StatisticalAnalysisTemporalFilterEnum.DAYS,
            grouping: null
        },
        showModalTable: false,
        showModalChart: false,
        rowSelected: null,
        updateGrid: ''
    })
